<!--续费订单-->
<template>
    <div style="height: 100%;width: 100%">
        <div>
            <van-sticky><!-- 粘性布局，顶部的位置固定 -->

                <div class="conopen" style="background-color: #f8f8f9">

                    <van-row type="flex" justify="space-between">
                        <van-col span="3">

                            <div style="padding: 17px">
                                <van-icon name="arrow-left" size="15px" @click="onback"/><!-- icon图标，返回路劲 -->
                            </div>
                        </van-col>
                        <van-col span="15">
                            <!-- 搜索组件 -->
                            <form action="/">
                                <van-search
                                        style="width: 100%;"
                                        v-model="value"
                                        placeholder="车牌号\车架号"
                                        show-action
                                        @search="onFind"
                                >
                                    <div slot="action" @click="onFind">搜索</div>
                                </van-search>
                            </form>
                        </van-col>
                        <van-col span="3">
                            <div style="padding: 17px">
                                <van-icon name="replay" size="15px" @click="reststart"/><!-- icon图标，刷新页面 -->
                            </div>
                        </van-col>
                        <!--                        <van-col span="3">-->
                        <!--                            <div style="padding: 17px">-->
                        <!--                                <van-icon name="plus" size="15px" @click="tosalesman"/>&lt;!&ndash; icon图标，创建订单页面 &ndash;&gt;-->
                        <!--                            </div>-->
                        <!--                        </van-col>-->
                    </van-row>

                </div>
                <div>
                    <!-- 下拉菜单 -->
                    <van-dropdown-menu>
                        <van-dropdown-item v-model="value1" :options="option1" @change="open"/>
                    </van-dropdown-menu>
                </div>
            </van-sticky>
        </div>

        <div>
            <div style="background-color: #f8f8f9">
                <van-pull-refresh v-model="isLoading" @refresh="refresh"><!-- 下拉刷新 -->
                    <!-- 上拉加载 -->
                    <van-list
                            v-model="loading"
                            :finished="finished"
                            finished-text="没有更多了"
                            @load="onLoad"
                    >
                        <!-- 加载图标 -->
                        <van-loading class="loader" v-if="loader"/>
                        <div v-for="(item,index) in installlist" class="content">
                            <Card style="width:100%">
                                <cell size="small" style="padding: 0px;">
                                    <label>订单号：
                                        <label style="color: #0077aa;">{{item.orderNum}}</label>
                                    </label><br/>
                                </cell>

                                <div class="mid">
                                <span class="count fl">车牌号:
                                    <label style="color: #0077aa;">{{item.positioningDeviceInfo.vehicleInfo?item.positioningDeviceInfo.vehicleInfo.registrationNum:null}}</label>
                                    <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                                    <span class="distance fr">|</span>
                                    <span class="time fr">车架号:
                                    <label style="color: #0077aa;">{{item.positioningDeviceInfo.vehicleInfo?item.positioningDeviceInfo.vehicleInfo.vin:null}}</label>
                                </span>
                                </div>
                                <div class="mid">
                                <span class="count fl">发动机号:
                                    <label style="color: #0077aa;">{{item.positioningDeviceInfo.vehicleInfo?item.positioningDeviceInfo.vehicleInfo.engineNum:null}}</label>
                                </span>
                                </div>

                                <div class="mid">
                                    <span class="count fl">旧服务到期时间:<label style="color: #0077aa;">{{new Date(item.oldServiceDatetime).Format('yyyy年MM月dd日')}}</label></span>
                                    <span class="distance fr">&nbsp;|&nbsp;</span>
                                    <span class="distance fr">上次收款总金额:
                                            <label style="color: #0077aa;">{{item.lastTotalAmount}}</label></span>
                                </div>
                                <div class="mid">
                                    <span class="count fl">新服务到期时间:<label style="color: #0077aa;">{{new Date(item.serviceDatetime).Format('yyyy年MM月dd日')}}</label></span>
                                    <span class="distance fr">&nbsp;|&nbsp;</span>
                                    <span class="distance fr">收款总金额:
                                            <label style="color: #0077aa;">{{item.totalAmount}}</label></span>
                                </div>
                                <div class="mid">
                                        <span class="count fl">终端主机号:
                                            <label style="color: #0077aa;">{{item.positioningDeviceInfo.terminalNum}}</label>
                                        </span>
                                </div>
                                <div class="mid">
                                        <span class="count fl">客户信息:
                                            <label style="color: #0077aa;">{{item.positioningDeviceInfo.vehicleInfo?item.positioningDeviceInfo.vehicleInfo.clientInfo.name:null+'('+(item.positioningDeviceInfo.vehicleInfo?item.positioningDeviceInfo.vehicleInfo.clientInfo.phoneNum:null)+')'}}</label>
                                        </span>
                                </div>
                                <div class="mid">
                                        <span class="count fl">业务跟进员:
                                            <label style="color: #0077aa;">{{item.businessUser.realName}}</label>
                                        </span><br>
                                    <van-button size="small" type="info"
                                                @click="torenewalordersDetail(item)">订单详情
                                    </van-button>&nbsp;&nbsp;
                                </div>
                                <div class="mid">
                                        <span class="count fl">备注:
                                            <label style="color: #0077aa;">{{item.remark}}</label>
                                        </span>
                                </div>
                                <div class="mid"  v-if="item.state==1">
                                    <van-button size="small" type="info"
                                                @click="renewalorderconfirmservicedatetimemodal(item)">确认服务期
                                    </van-button>&nbsp;&nbsp;
                                    <van-button size="small" type="info" @click="renewalorderrefuseservicemodal(item)">
                                        拒绝服务
                                    </van-button>&nbsp;&nbsp;
                                </div>

                            </Card>
                            <div style="height: 3px"></div>
                            <!--                        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">-->
                            <!--                        </van-divider>-->
                        </div>


                    </van-list>
                </van-pull-refresh>
            </div>
        </div>

        <div>
            <Modal
                    v-model="modal1"
                    title="确认续费服务期"
                    @on-ok="ok"
                    @on-cancel="cancel">
                <van-cell-group>
                    <van-field
                            readonly
                            clickable
                            required
                            :value="money"
                            @click="show = true"
                            label="总金额"
                            placeholder="请输入总金额"
                    />
                    <van-number-keyboard
                            v-model="money"
                            :show="show"
                            transition
                            extra-key="."
                            :maxlength="10"
                            @blur="show = false"
                    />
                    <van-field
                            readonly
                            required
                            clickable
                            label="日期"
                            v-model="serviceDatetime"
                            placeholder="服务到期时间"
                            @click="showPicker = true"
                    />
                    <van-popup v-model="showPicker" position="bottom">
                        <van-datetime-picker
                                v-model="currentDate"
                                :currentDate="currentDate"
                                type="date"
                                :min-date="minDate"
                                @cancel="onCancel"
                                @confirm="onConfirm(currentDate)"
                        />
                    </van-popup>


                    <van-field
                            readonly
                            clickable
                            required
                            :value="renewalOrder.billType"
                            label="开票类型"
                            placeholder="请选择类型"
                    >
                        <van-dropdown-menu slot="input">
                            <van-dropdown-item v-model="value2" :options="option2" @change="changebillType"/>
                        </van-dropdown-menu>
                    </van-field>


                    <van-field
                            v-model="renewalOrder.remark"
                            rows="2"
                            autosize
                            type="textarea"
                            maxlength="250"
                            placeholder="请输入备注信息"
                            show-word-limit
                    />
                </van-cell-group>
            </Modal>
            <Modal
                    v-model="modal2"
                    title="拒绝服务"
                    @on-ok="ok2"
                    @on-cancel="cancel">
                <van-cell-group>
                    <van-field
                            v-model="renewalOrder2.remark"
                            rows="2"
                            autosize
                            type="textarea"
                            maxlength="250"
                            placeholder="请输入备注信息"
                            show-word-limit
                    />
                </van-cell-group>
            </Modal>
        </div>

    </div>
</template>

<script>

    import Vue from 'vue'
    import store from '@/store'
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
        NumberKeyboard,
    } from 'vant'


    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu).use(NumberKeyboard)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast);

    export default {
        name: "renewalorders",
        data() {
            return {
                value: '',
                serviceDatetime:'',
                show: false,

                currentDate: new Date(),
                showPicker: false,
                minDate: new Date(),

                activeName: [],

                i: [],
                installlist: [],

                value1: 0,
                option1: [
                    {text: '待确认续费期', value: 0},
                    {text: '待收款', value: 1},
                    {text: '已续费', value: 2},
                    {text: '待回访', value: 3},
                    {text: '待确认停止服务', value: 4},
                    {text: '停止服务', value: 5},
                    {text: '作废', value: 6},
                    {text: '异常', value: 7},
                ],

                value2: 0,
                option2: [
                    {text: '增值税发票', value: 0},
                    {text: '增值税专用发票', value: 1},
                    {text: '增值税普通发票', value: 2},
                ],

                isLoading: false,
                loading: false,
                finished: false,
                loader: false,

                modal1: false,
                money:'',
                renewalOrder: {
                    id: null,
                    serviceDatetime: null,
                    billType: 1,
                    totalAmount: 0,
                    remark: ''
                },
                modal2: false,
                renewalOrder2: {
                    id: null,
                    remark: ''
                }
            }
        },
        methods: {
            torenewalordersDetail(e){
                this.$router.push({
                    name: 'renewalordersDetail',
                    params: {'renewalordersDetailid': e.id}
                })
            },
            // <!-- icon返回路劲 -->
            onback() {
                this.$router.push({
                    name: 'myMenu'
                })
            },
            onLoad() {
                this.i.push(1)
                if (this.value1 == 0) {
                    let bb
                    let aa = []
                    aa.push(genQueryParam('state', 'EQ', 1))
                    store.dispatch('RenewalOrderServ_GetMyBusinessPage', {
                        params: null,
                        urlparams: {
                            q: aa,
                            p: this.i.length,
                            keyword: this.value,
                            sort: genSortParam('createDatetime', false)
                        }
                    }).then((res) => {
                        console.log(res)
                        if (res.data.content.length != 0) {
                            for (let j = 0; j < res.data.content.length; j++) {
                                this.installlist.push(res.data.content[j]);
                            }
                            bb = res.data.totalElements
                            // this.installlist = res.data.content
                            // 加载状态结束
                            this.loading = false;

                            // 数据全部加载完成
                            if (this.installlist.length >= bb) {
                                this.finished = true;
                            }
                        } else {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;

                        }
                    }).catch((err) => {
                        // 加载状态结束
                        this.loading = false;
                        this.finished = true;
                        Toast(err)
                        console.log(err)
                    })
                } else if (this.value1 == 1) {
                    let bb
                    let aa = []
                    aa.push(genQueryParam('state', 'EQ', 2))
                    store.dispatch('RenewalOrderServ_GetMyBusinessPage', {
                        params: null,
                        urlparams: {
                            q: aa,
                            p: this.i.length,
                            keyword: this.value,
                            sort: genSortParam('createDatetime', false)
                        }
                    }).then((res) => {
                        console.log(res)
                        if (res.data.content.length != 0) {
                            for (let j = 0; j < res.data.content.length; j++) {
                                this.installlist.push(res.data.content[j]);
                            }
                            bb = res.data.totalElements
                            // this.installlist = res.data.content
                            // 加载状态结束
                            this.loading = false;

                            // 数据全部加载完成
                            if (this.installlist.length >= bb) {
                                this.finished = true;
                            }
                        } else {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;

                        }
                    }).catch((err) => {
                        // 加载状态结束
                        this.loading = false;
                        this.finished = true;
                        Toast(err)
                        console.log(err)
                    })
                } else if (this.value1 == 2) {
                    let bb
                    let aa = []
                    aa.push(genQueryParam('state', 'EQ', 3))
                    store.dispatch('RenewalOrderServ_GetMyBusinessPage', {
                        params: null,
                        urlparams: {
                            q: aa,
                            p: this.i.length,
                            keyword: this.value,
                            sort: genSortParam('createDatetime', false)
                        }
                    }).then((res) => {
                        console.log(res)
                        if (res.data.content.length != 0) {
                            for (let j = 0; j < res.data.content.length; j++) {
                                this.installlist.push(res.data.content[j]);
                            }
                            bb = res.data.totalElements
                            // this.installlist = res.data.content
                            // 加载状态结束
                            this.loading = false;

                            // 数据全部加载完成
                            if (this.installlist.length >= bb) {
                                this.finished = true;
                            }
                        } else {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;

                        }
                    }).catch((err) => {
                        // 加载状态结束
                        this.loading = false;
                        this.finished = true;
                        Toast(err)
                        console.log(err)
                    })
                } else if (this.value1 == 3) {
                    let bb
                    let aa = []
                    aa.push(genQueryParam('state', 'EQ', 4))
                    store.dispatch('RenewalOrderServ_GetMyBusinessPage', {
                        params: null,
                        urlparams: {
                            q: aa,
                            p: this.i.length,
                            keyword: this.value,
                            sort: genSortParam('createDatetime', false)
                        }
                    }).then((res) => {
                        console.log(res)
                        if (res.data.content.length != 0) {
                            for (let j = 0; j < res.data.content.length; j++) {
                                this.installlist.push(res.data.content[j]);
                            }
                            bb = res.data.totalElements
                            // this.installlist = res.data.content
                            // 加载状态结束
                            this.loading = false;

                            // 数据全部加载完成
                            if (this.installlist.length >= bb) {
                                this.finished = true;
                            }
                        } else {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;

                        }
                    }).catch((err) => {
                        // 加载状态结束
                        this.loading = false;
                        this.finished = true;
                        Toast(err)
                        console.log(err)
                    })
                } else if (this.value1 == 4) {
                    let bb
                    let aa = []
                    aa.push(genQueryParam('state', 'EQ', 5))
                    store.dispatch('RenewalOrderServ_GetMyBusinessPage', {
                        params: null,
                        urlparams: {
                            q: aa,
                            p: this.i.length,
                            keyword: this.value,
                            sort: genSortParam('createDatetime', false)
                        }
                    }).then((res) => {
                        console.log(res)
                        if (res.data.content.length != 0) {
                            for (let j = 0; j < res.data.content.length; j++) {
                                this.installlist.push(res.data.content[j]);
                            }
                            bb = res.data.totalElements
                            // this.installlist = res.data.content
                            // 加载状态结束
                            this.loading = false;

                            // 数据全部加载完成
                            if (this.installlist.length >= bb) {
                                this.finished = true;
                            }
                        } else {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;

                        }
                    }).catch((err) => {
                        // 加载状态结束
                        this.loading = false;
                        this.finished = true;
                        Toast(err)
                        console.log(err)
                    })
                } else if (this.value1 == 5) {
                    let bb
                    let aa = []
                    aa.push(genQueryParam('state', 'EQ', 6))
                    store.dispatch('RenewalOrderServ_GetMyBusinessPage', {
                        params: null,
                        urlparams: {
                            q: aa,
                            p: this.i.length,
                            keyword: this.value,
                            sort: genSortParam('createDatetime', false)
                        }
                    }).then((res) => {
                        console.log(res)
                        if (res.data.content.length != 0) {
                            for (let j = 0; j < res.data.content.length; j++) {
                                this.installlist.push(res.data.content[j]);
                            }
                            bb = res.data.totalElements
                            // this.installlist = res.data.content
                            // 加载状态结束
                            this.loading = false;

                            // 数据全部加载完成
                            if (this.installlist.length >= bb) {
                                this.finished = true;
                            }
                        } else {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;

                        }
                    }).catch((err) => {
                        // 加载状态结束
                        this.loading = false;
                        this.finished = true;
                        Toast(err)
                        console.log(err)
                    })
                } else if (this.value1 == 6) {
                    let bb
                    let aa = []
                    aa.push(genQueryParam('state', 'EQ', 0))
                    store.dispatch('RenewalOrderServ_GetMyBusinessPage', {
                        params: null,
                        urlparams: {
                            q: aa,
                            p: this.i.length,
                            keyword: this.value,
                            sort: genSortParam('createDatetime', false)
                        }
                    }).then((res) => {
                        console.log(res)
                        if (res.data.content.length != 0) {
                            for (let j = 0; j < res.data.content.length; j++) {
                                this.installlist.push(res.data.content[j]);
                            }
                            bb = res.data.totalElements
                            // this.installlist = res.data.content
                            // 加载状态结束
                            this.loading = false;

                            // 数据全部加载完成
                            if (this.installlist.length >= bb) {
                                this.finished = true;
                            }
                        } else {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;

                        }
                    }).catch((err) => {
                        // 加载状态结束
                        this.loading = false;
                        this.finished = true;
                        Toast(err)
                        console.log(err)
                    })
                } else if (this.value1 == 7) {
                    let bb
                    let aa = []
                    aa.push(genQueryParam('state', 'EQ', -1))
                    store.dispatch('RenewalOrderServ_GetMyBusinessPage', {
                        params: null,
                        urlparams: {
                            q: aa,
                            p: this.i.length,
                            keyword: this.value,
                            sort: genSortParam('createDatetime', false)
                        }
                    }).then((res) => {
                        console.log(res)
                        if (res.data.content.length != 0) {
                            for (let j = 0; j < res.data.content.length; j++) {
                                this.installlist.push(res.data.content[j]);
                            }
                            bb = res.data.totalElements
                            // this.installlist = res.data.content
                            // 加载状态结束
                            this.loading = false;

                            // 数据全部加载完成
                            if (this.installlist.length >= bb) {
                                this.finished = true;
                            }
                        } else {
                            // 加载状态结束
                            this.loading = false;
                            this.finished = true;

                        }
                    }).catch((err) => {
                        // 加载状态结束
                        this.loading = false;
                        this.finished = true;
                        Toast(err)
                        console.log(err)
                    })
                }
            },
            //日期选择开关
            onCancel() {
                this.showPicker = false
            },
            onConfirm(e) {
                this.serviceDatetime = e.Format('yyyy-MM-dd')
                this.renewalOrder.serviceDatetime = new Date(this.serviceDatetime)
                this.showPicker = false
            },
            refresh() {
                setTimeout(() => {
                    this.i = []
                    this.installlist = []
                    this.finished = false;
                    this.onLoad()
                    this.isLoading = false;
                }, 500);
            },
            reststart() {
                // <!-- icon图标刷新方法 -->
                this.loader = true
                setTimeout(() => {
                    this.i = []
                    this.installlist = []
                    this.finished = false;
                    this.onLoad()
                    this.loader = false
                }, 500)
            },
            onFind() {
                this.i = []
                this.installlist = []
                this.finished = false;
                this.onLoad()
            },
            open() {
                this.i = []
                this.installlist = []
                this.finished = false;
                this.onLoad()
            },
            changebillType() {
                if (this.value2 == 0) {
                    this.renewalOrder.billType = 1
                } else if (this.value2 == 1) {
                    this.renewalOrder.billType = 2
                } else if (this.value2 == 2) {
                    this.renewalOrder.billType = 3
                }
            },
            renewalorderconfirmservicedatetimemodal(e) {
                console.log(e)
                this.modal1 = true
                this.renewalOrder.totalAmount=this.money
                this.renewalOrder.id=e.id
            },
            renewalorderrefuseservicemodal(e) {
                console.log(e)
                this.modal2 = true
                this.renewalOrder2.id=e.id
            },
            ok() {
                console.log(this.renewalOrder)
                store.dispatch('RenewalOrderServ_ConfirmServiceDatetime', {
                    params: this.renewalOrder,
                    urlparams: null
                }).then((res) => {
                    Toast('确认成功')
                }).catch((err) => {
                    Toast(err)
                })
            },
            ok2() {
                store.dispatch('RenewalOrderServ_RefuseService', {
                    params: this.renewalOrder2,
                    urlparams: null
                }).then((res) => {
                    Toast('确认成功')
                }).catch((err) => {
                    Toast(err)
                })
            },
            cancel() {
            },
        },
        mounted() {
        }
    }
</script>

<style scoped>

</style>
